const projectTitle = {
  short: "Strength",
  long: "Strength Training"
}

export default projectTitle;